export default {
    calcTimerCounter(time){
        if(!time){
            return null;
        }

        return this.getTimerData((new Date(time * 1000)).getTime());
    },
    getTimerData(timeMilliEnd){
        let difference_ms = timeMilliEnd - (new Date()).getTime();

        difference_ms = difference_ms / 1000;
        const secs  = Math.floor(difference_ms % 60);
        
        difference_ms = difference_ms / 60;
        const mins = Math.floor(difference_ms % 60);

        difference_ms = difference_ms / 60;
        const hours = Math.floor(difference_ms);

        if(hours+mins+secs<=0){
            return null;
        }
        
        return {
            secs: secs,
            mins: mins,
            hours: hours
        };
    },
    formatNumberCounter(value){
        return (value < 10 ? '0' : '') + value;
    }
};